const shareUrls = {
  wechat: {
    name: '微信',
    icon: 'data:image/svg+xml;charset=utf8,%3Csvg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cpath fill="%23FFF" d="M0 40h39.852V0H0z" opacity="0"/%3E%3Cpath fill="%2307C160" d="M15.382 23.872a1.11 1.11 0 0 1-1.47-.449l-.072-.159-3.034-6.658a.555.555 0 0 1 .835-.68l3.58 2.55a1.658 1.658 0 0 0 1.48.17L33.54 11.15c-3.018-3.558-7.989-5.883-13.614-5.883-9.205 0-16.666 6.218-16.666 13.89 0 4.184 2.244 7.952 5.758 10.499a1.108 1.108 0 0 1 .408 1.258c-.28 1.047-.73 2.723-.75 2.802-.036.131-.09.269-.09.406 0 .307.248.555.556.555a.62.62 0 0 0 .32-.103l3.65-2.107c.274-.158.564-.256.884-.256.171 0 .336.026.49.074 1.702.49 3.54.761 5.44.761 9.205 0 16.667-6.218 16.667-13.89 0-2.322-.688-4.51-1.898-6.435l-19.19 11.08-.122.07z"/%3E%3C/g%3E%3C/svg%3E',
    url: 'https://open.weixin.qq.com/connect/qrconnect?http%3A%2F%2Fwww.baidu.com',
    mobileOnly: true,
    copyLink: true
  },
  weibo: {
    name: '微博',
    icon: 'data:image/svg+xml;charset=utf8,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 404 323"%3E%3Cg fill="none"%3E%3Cg%3E%3Cpath d="M29.136 219.44c0 45.849 59.707 83.045 133.364 83.045 73.657 0 133.363-37.197 133.363-83.045 0-45.859-59.707-83.045-133.364-83.045-73.656 0-133.363 37.186-133.363 83.045" fill="%23FEFEFE"/%3E%3Cpath d="M165.616 295.712c-65.199 6.433-121.469-23.032-125.714-65.833-4.234-42.791 45.204-82.708 110.383-89.151 65.209-6.453 121.469 23.011 125.714 65.802 4.213 42.812-45.195 82.729-110.383 89.182m130.387-142.077c-5.553-1.657-9.358-2.782-6.443-10.084 6.29-15.811 6.934-29.465.123-39.191-12.794-18.276-47.772-17.284-87.862-.501 0-.01-12.59 5.512-9.368-4.469 6.177-19.831 5.236-36.44-4.357-46.023-21.743-21.764-79.599.818-129.201 50.4C21.75 140.933.18 180.308.18 214.344c0 65.117 83.516 104.707 165.211 104.707 107.1 0 178.343-62.213 178.343-111.62 0-29.854-25.139-46.79-47.731-53.796" fill="%23D52C2B"/%3E%3Cpath d="M367.124 34.465c-25.865-28.677-64.023-39.61-99.235-32.124h-.01c-8.141 1.749-13.336 9.757-11.598 17.888 1.728 8.151 9.747 13.357 17.898 11.608 25.057-5.318 52.159 2.465 70.558 22.827 18.348 20.373 23.349 48.16 15.484 72.511v.01c-2.567 7.926 1.769 16.415 9.716 18.982 7.916 2.557 16.425-1.78 18.992-9.695v-.051c11.045-34.262 4.05-73.31-21.805-101.956" fill="%23E79115"/%3E%3Cpath d="M327.396 70.305c-12.59-13.96-31.162-19.268-48.324-15.617-7.016 1.493-11.495 8.397-9.972 15.412 1.483 6.985 8.386 11.485 15.372 9.961v.02c8.407-1.78 17.489.808 23.645 7.609 6.167 6.832 7.814 16.139 5.165 24.3h.02c-2.199 6.811 1.534 14.144 8.345 16.353 6.832 2.178 14.144-1.544 16.343-8.366 5.392-16.689 2.017-35.711-10.594-49.672" fill="%23E79115"/%3E%3Cpath d="M169.206 218.197c-2.27 3.897-7.312 5.768-11.27 4.142-3.886-1.595-5.103-5.942-2.884-9.788 2.27-3.805 7.108-5.666 10.984-4.122 3.937 1.433 5.349 5.841 3.17 9.768m-20.761 26.672c-6.32 10.043-19.82 14.451-29.986 9.818-10.023-4.561-12.978-16.251-6.678-26.059 6.218-9.777 19.278-14.124 29.373-9.89 10.216 4.358 13.468 15.955 7.291 26.131m23.676-71.202c-31.019-8.08-66.089 7.384-79.558 34.732-13.725 27.869-.45 58.817 30.897 68.942 32.451 10.462 70.722-5.584 84.037-35.663 13.112-29.423-3.273-59.716-35.376-68.011" fill="%23060101"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E',
    url: 'https://service.weibo.com/share/share.php?title={title}&url={url}&pic={image}'
  },
  qq: {
    name: 'QQ',
    icon: 'data:image/svg+xml,%3csvg xmlns="http://www.w3.org/2000/svg" width="56" height="35" fill="none" viewBox="0 0 56 35"%3e%3cpath fill="%23f9ae08" d="M9.56 28.668c-1.981 0-3.8-.666-4.972-1.662-.594.179-1.355.466-1.835.823-.41.305-.359.615-.285.741.325.55 5.577.351 7.094.18v-.082z"/%3e%3cpath fill="%23f9ae08" d="M9.56 28.668c1.98 0 3.8-.666 4.971-1.662.595.179 1.356.466 1.836.823.41.305.359.615.285.741-.326.55-5.578.351-7.094.18v-.082z"/%3e%3cpath fill="%23000" d="M9.573 16.55c3.272-.023 5.894-.476 6.784-.72a.84.84 0 0 0 .325-.163c0-.03.013-.535.013-.796-.002-4.39-2.063-8.802-7.135-8.802-5.073 0-7.134 4.411-7.134 8.802 0 .261.013.767.013.796 0 0 .093.098.261.145.821.229 3.493.715 6.849.738zM18.465 20.391c-.204-.655-.48-1.42-.76-2.157 0 0-.188-.005-.285.016-2.33.503-5.536.869-7.847.841h-.024c-2.311.028-5.632-.356-7.847-.84-.098-.021-.285-.017-.285-.017-.28.735-.558 1.5-.76 2.157-.893 2.785-.71 4.331-.413 4.444.423.163 1.99-2.347 1.99-2.347 0 2.457 2.207 6.227 7.26 6.263h.135c5.053-.036 7.26-3.806 7.26-6.263 0 0 1.567 2.508 1.99 2.347.295-.113.478-1.659-.411-4.444z"/%3e%3cpath fill="%23f9ae08" d="M9.573 15.111c1.68 0 3.268-.597 4.005-1.117.258-.182.189-.453-.082-.58-.31-.147-.635-.236-1.005-.322a13.4 13.4 0 0 0-2.917-.332H9.55c-.934 0-1.98.114-2.917.332-.37.085-.695.175-1.004.322-.271.127-.34.398-.082.58.737.52 2.325 1.117 4.005 1.117h.024z"/%3e%3cpath fill="%23fff" d="M9.571 19.078h-.024c-1.569.02-3.471-.053-5.314-.417a15 15 0 0 0-.172 3.449c.207 3.477 2.262 5.663 5.435 5.695h.128c3.172-.032 5.228-2.218 5.435-5.695a15 15 0 0 0-.172-3.449c-1.843.366-3.745.437-5.316.417"/%3e%3cpath fill="%23f10824" d="M5.07 22.237c0 .087.063.163.15.175.856.13 1.864.178 2.835.104a.177.177 0 0 0 .162-.178v-3.395c-.997-.056-2.072-.14-3.146-.322z"/%3e%3cpath fill="%23f10824" d="M9.549 19.23c-2.53 0-5.424-.294-8.132-.994l1.024-2.568s3.014.756 7.108.756h.024c4.093 0 7.108-.755 7.108-.755l1.024 2.567c-2.709.702-5.602.994-8.132.994z"/%3e%3cpath fill="%23fff" d="M7.755 12.44c-.687.031-1.275-.756-1.312-1.756-.037-1.002.49-1.84 1.178-1.872.687-.03 1.274.757 1.312 1.759.037 1.002-.489 1.84-1.178 1.87M12.677 10.684c-.037 1.001-.625 1.789-1.312 1.757-.688-.03-1.215-.868-1.178-1.87s.625-1.79 1.312-1.76 1.215.87 1.178 1.873"/%3e%3cpath fill="%23000" d="M8.58 10.737c.034.431-.201.815-.525.856-.325.042-.615-.273-.65-.705-.034-.432.201-.815.523-.857.326-.042.617.274.651.706M10.552 10.83c.305-.527 1.02-.693 1.543-.407.374.2.106.657-.232.473-.32-.172-.764-.16-.998.139-.185.235-.456.041-.313-.207zM53.977 23.041a8.06 8.06 0 0 0 2.013-5.77c-.207-4.095-3.517-7.423-7.592-7.63-4.76-.244-8.67 3.686-8.429 8.47.207 4.096 3.518 7.422 7.594 7.63a7.97 7.97 0 0 0 4.881-1.355l.674.902c.05.07.133.11.218.11h2.208c.079 0 .125-.09.077-.155l-1.643-2.202zm-5.998.809c-3.307 0-5.99-2.758-5.99-6.16 0-3.401 2.683-6.159 5.99-6.159s5.991 2.758 5.991 6.16a6.24 6.24 0 0 1-1.213 3.714l-1.27-1.703a.27.27 0 0 0-.219-.11H49.06a.097.097 0 0 0-.077.155l2.3 3.081a5.85 5.85 0 0 1-3.304 1.022M38.344 17.273c-.207-4.096-3.518-7.423-7.592-7.631-4.76-.243-8.669 3.687-8.428 8.47.206 4.096 3.517 7.423 7.593 7.63a7.97 7.97 0 0 0 4.882-1.354l.673.902c.051.069.133.11.218.11h2.209c.078 0 .124-.091.076-.155l-1.642-2.202a8.06 8.06 0 0 0 2.013-5.77zm-4.504 2.43a.27.27 0 0 0-.218-.109h-2.208a.097.097 0 0 0-.077.155l2.3 3.081a5.85 5.85 0 0 1-3.303 1.021c-3.308 0-5.991-2.757-5.991-6.159s2.683-6.16 5.99-6.16c3.309 0 5.992 2.758 5.992 6.16a6.24 6.24 0 0 1-1.214 3.714z"/%3e%3c/svg%3e',
    url: 'https://connect.qq.com/widget/shareqq/index.html?url={url}&title={title}&desc={desc}&summary={summary}&site={site}'
  },
  douban: {
    name: '豆瓣',
    icon: 'https://img1.doubanio.com/favicon.ico',
    url: 'https://www.douban.com/share/service?href={url}&name={title}&text={desc}'
  },
  // zhihu: {
  //   name: '知乎',
  //   icon: 'https://static.zhihu.com/heifetz/favicon.ico',
  //   url: 'https://link.zhihu.com/?target={url}&title={title}'
  // },
  xiaohongshu: {
    name: '小红书',
    icon: 'https://ts2.tc.mm.bing.net/th/id/ODF.uBc5FfhX8MukVL5zLsgKqg?w=32&h=32&qlt=90&pcl=fffffa&o=6&pid=1.2',
    mobileOnly: true,
    copyLink: true
  },
  // dingtalk: {
  //   name: '钉钉',
  //   icon: 'https://ts3.tc.mm.bing.net/th/id/ODF.mcX-UH86Bk7NgRqHCd_MIA?w=32&h=32&qlt=90&pcl=fffffc&o=6&pid=1.2',
  //   url: 'https://oapi.dingtalk.com/robot/send?access_token='
  // },
  twitter: {
    name: 'Twitter',
    icon: 'https://api.iconify.design/logos/twitter.svg',
    url: 'https://twitter.com/intent/tweet?url={url}&text={title}&via='
  },
  facebook: {
    name: 'Facebook',
    icon: 'https://api.iconify.design/logos/facebook.svg',
    url: 'https://www.facebook.com/sharer/sharer.php?u={url}&t={title}'
  },
  linkedin: {
    name: 'LinkedIn',
    icon: 'https://api.iconify.design/logos/linkedin.svg',
    url: 'https://www.linkedin.com/sharing/share-offsite/?url={url}'
  },
  reddit: {
    name: 'Reddit',
    icon: 'https://api.iconify.design/logos/reddit.svg',
    url: 'https://www.reddit.com/submit?url={url}&title={title}'
  },
  telegram: {
    name: 'Telegram',
    icon: 'https://api.iconify.design/logos/telegram.svg',
    url: 'https://t.me/share/url?url={url}&text={title}'
  },
  whatsapp: {
    name: 'WhatsApp',
    icon: 'https://api.iconify.design/logos/whatsapp.svg',
    url: 'https://api.whatsapp.com/send?text={title}%20{url}'
  },
  copy: {
    name: '复制链接',
    icon: 'https://api.iconify.design/mdi/content-copy.svg'
  }
}

const generateShareUrl = (platform, options) => {
  const config = shareUrls[platform]
  if (!config) return null
  
  const defaults = {
    url: window.location.href,
    title: document.title,
    desc: '',
    summary: '',
    site: window.location.hostname,
    image: ''
  }
  
  const opts = { ...defaults, ...options }
  
  let url = config.url
  if (url.includes('{url}')) {
    url = url.replace(/{url}/g, encodeURIComponent(opts.url))
  }
  if (url.includes('{title}')) {
    url = url.replace(/{title}/g, encodeURIComponent(opts.title))
  }
  if (url.includes('{desc}')) {
    url = url.replace(/{desc}/g, encodeURIComponent(opts.desc))
  }
  if (url.includes('{summary}')) {
    url = url.replace(/{summary}/g, encodeURIComponent(opts.summary))
  }
  if (url.includes('{site}')) {
    url = url.replace(/{site}/g, encodeURIComponent(opts.site))
  }
  if (url.includes('{image}')) {
    url = url.replace(/{image}/g, encodeURIComponent(opts.image))
  }
  
  return url
}

const copyToClipboard = async (text) => {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text)
    return true
  }
  
  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.style.position = 'fixed'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  
  try {
    document.execCommand('copy')
    document.body.removeChild(textarea)
    return true
  } catch (err) {
    document.body.removeChild(textarea)
    return false
  }
}

export { shareUrls, generateShareUrl, copyToClipboard }
